import React, { useEffect, useContext } from 'react';
import './FileInput.css'
import { CurrentUserContext } from '../../../Contexts/CurrentUserContext';
import api from '../../../Utils/Api';
import base64 from 'base64-js'


const FileInput = ({ setAvatar, setIsInputOpened }) => {
    const { token, setUser, user } = useContext(CurrentUserContext);

    // useEffect(() => {

    //         .then((res) => {
    //         })
    //         .catch((e) => {
    //           console.log(e);
    //         });


    //   }, [isLoggedIn]);

    const handleFile = (e) => {
       // console.log(e.target.files)
        var file = e.target.files;
        const reader = new FileReader()
        const readerFile = new FileReader()
        if (file) {
            reader.onload = function () {
                var avatar = reader.result
                setAvatar(avatar);
                setUser({ ...user, avatar: avatar })
                // console.log(avatar)
                // api.changeAvatar(token, avatar, file[0].name )

            };
            readerFile.onload = function () {
                // console.log(reader)
                var content = base64.fromByteArray(new Uint8ClampedArray(readerFile.result));
                api.changeAvatar(token, content, file[0].name)
                    .then((res) => {
                      //  console.log(res)

                    })
                    .catch((e) => {
                        console.log(e);
                    });
            };
            readerFile.readAsArrayBuffer(file[0]);
            reader.readAsDataURL(file[0])
        } else {
            return
        }
        setIsInputOpened(false)
    }



    return (


        <label className='fileInput__label' onChange={(e) => handleFile(e)} htmlFor="file">
            <input accept="image/png, image/jpeg, image/jpg" className='fileInput__input' type='file' id='file' name='file'
            />
            <p >Перетащите файл или нажмите</p>
            <p >.JPG или .PNG не более 2мб</p>
        </label>


    )
}

export default FileInput